import { styled, alpha } from "@mui/material/styles";
import {
  Box,
  Card,
  TableContainer,
  TableRow,
  TableCell,
  TextField,
  Accordion,
  Chip,
} from "@mui/material";
import { softColors } from "../../constants/colors";

export const StyledContainer = styled(Box)(({  }) => ({
  width: "100%",
  backgroundColor: softColors.background,
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  boxShadow: "none",
  border: `1px solid ${softColors.border}`,
  backgroundColor: "#ffffff",
  width: "100%",
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  "& .MuiTable-root": {
    borderCollapse: "separate",
    borderSpacing: "0 4px",
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: alpha(softColors.primary, 0.02),
  },
  "&:hover": {
    backgroundColor: softColors.hover,
  },
  transition: "background-color 0.2s ease",
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(2),
  borderBottom: `1px solid ${softColors.border}`,
  color: softColors.text,
  fontSize: "0.875rem",
}));

export const StyledTableHeadCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#ffffff",
  color: softColors.text,
  fontWeight: 600,
  padding: theme.spacing(2),
  borderBottom: `2px solid ${softColors.border}`,
  fontSize: "0.875rem",
}));

export const StyledTableBodyCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(2),
  borderBottom: `1px solid ${softColors.border}`,
  color: softColors.text,
  fontSize: "0.875rem",
}));


export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  boxShadow: "none",
  "&:before": {
    display: "none",
  },
  borderRadius: `${theme.spacing(1)}px !important`,
  border: `1px solid ${softColors.border}`,
  backgroundColor: "#ffffff",
}));

export const StyledDetailCard = styled(Card)(({ theme }) => ({
  backgroundColor: "#ffffff",
  borderRadius: theme.spacing(1.5),
  border: `1px solid ${softColors.border}`,
  boxShadow: "none",
}));

export const StyledDetailBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
  backgroundColor: softColors.background,
  height: "100%",
  border: `1px solid ${softColors.border}`,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
}));

export const StyledChip = styled(Chip)(({ theme, status }) => ({
  borderRadius: "16px",
  fontWeight: "medium",
  backgroundColor:
    status === "success"
      ? alpha(softColors.success, 0.1)
      : alpha(softColors.error, 0.1),
  color: status === "success" ? softColors.success : softColors.error,
  border: `1px solid ${
    status === "success" ? softColors.success : softColors.error
  }`,
  "& .MuiChip-label": {
    px: 2,
  },
}));